import { Outlet } from "react-router-dom";
import AssetRetrievalsGrid from "components/AssetRetrievals/AssetRetrievalsGrid";

export default function AssetRetrievals() {
  return (
    <>
      <AssetRetrievalsGrid />
      <Outlet />
    </>
  );
}
